<template>
  <a-modal
    v-model="visible.reportConfirmVisible"
    v-if="visible.reportConfirmVisible"
    title="导出"
    width="600px"
    destroyOnClose
    @ok="ok"
    @cancel="cancel"
    cancelText="取消"
    okText="确定"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="报表类型">
        {{ typeName }}
      </a-form-item>
      <a-form-item label="文件名称">
        <a-input v-decorator="['fileName', { rules: [{ required: true, message: '请输入文件名称' },{validator: checkName}] }]" placeholder="请输入文件名称" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { formulaMixins } from '../unitls'
import moment from 'moment'
export default {
  props: ['priceSource'],
  mixins:[formulaMixins],
  data() {
    return {
      form: this.$form.createForm(this),
      textLen: 40
    }
  },
  watch: {
    'visible.reportConfirmVisible': {
      handler(val){
        if(val) setTimeout(() => {
          this.form.setFieldsValue({fileName: `${this.typeName}${moment(new Date()).format('YYYYMMDD')}`})
        }, 0)
      },
      deep: true
    },
  },
  computed: {
    typeName() {
      return this.reportTypes[this.reportKey]
    },
  },
  methods: {
    checkName(rule, value, callback) {
      if(value){
        // let reg2 = /[/\\:*?“<>|]/im;
        let reg2 = /[*[\]：？<>/、\\.]/im;
        if(reg2.test(value)) callback(`字符数 ≤ ${this.textLen}，特殊字符限制：*[]：？<>/、\\.`);
        if(value.length > this.textLen) callback(`名称长度不能超过${this.textLen}个字符`);
      }
      callback()
    },
    turnTo(){
      this.$router.push('/system/nhf-export-management?name=导出管理')
      this.$notification.close('a')
    },
    ok() {
      this.form.validateFields(async (err,values) => {
        if(!err){
          let urlObj = {
            0: '/nhf-app/formulatask/asyncExportRawUseContrastTask',
            1: '/nhf-app/formulatask/asyncFormulaCostContrastTask',
            2: '/nhf-app/formulatask/asyncExportRawUseContrastTask',
            3: '/nhf-app/formulatask/asyncRawWeightContrastTask',
            4: '/nhf-app/formulataskformularaw/asyncExportTaskFormulaRawAssessPage',
            5: '/nhf-app/formulatask/asyncFormulaTaskRawContrastTask',
          }
          let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0
          let params = {
            aliasFlag,
            taskId: this.taskId,
            priceSource: this.reportKey === 1 ? this.priceSource : undefined,
            ...values
          }
          if (this.reportKey === 0) {
            params.isFilterDiff = 1;
          }

          if (this.reportKey === 2) {
            params.isFilterDiff = 0;
          }
          await this.$http.get(urlObj[this.reportKey],{params})
          this.$notification.success({
            key: 'a',
            message: <h3>导出任务提示</h3>,
            duration: 3,
            description: <div>
              <p>你所提交的导出任务已经创建，请前往导出管理中查看进度和下载文件！</p>
              <a onClick={this.turnTo}>前往导出管理</a>
            </div>,
          });
          this.toggleVisible('reportConfirmVisible')
          this.setState({reportVisible: false})
        }
      })
    },
    cancel(){
      this.toggleVisible('reportConfirmVisible')
    },
  }
}
</script>